import { UndeliveredOrdersReport } from '@api/order-reporting/types/UndeliveredOrdersReport';
import { UndeliveredGridData } from '@pages/reporting-pages/undelivered-orders/types/UndeliveredGridData';
import { getParsedUnversionedSystemId } from '@utils/getParsedSystemId';
import { format, parseISO } from 'date-fns';
import { renderLitresToHL, numberWithSpaces } from 'components/global/utils';
import { valueExist } from '@utils/typescriptGuards';



export const convertToGridData = (apiData: UndeliveredOrdersReport[] | undefined | null): UndeliveredGridData[] | null => {
	if (!apiData) return null;

	let gridData: UndeliveredGridData[] = [];
	if (apiData.length === 0)
		return gridData;
	

	gridData = apiData.map(x => ({
		...x,
		orderClientId: getParsedUnversionedSystemId(x.orderUnversionedSystemId).clientId,
		orderRequiredDeliveryDate: x.orderRequiredDeliveryDate ? format(parseISO(x.orderRequiredDeliveryDate), 'dd.MM.yyyy') : '-',
		orderRequiredDeliveryDateISO: x.orderRequiredDeliveryDate ? x.orderRequiredDeliveryDate : '-',
		orderSentVolume: valueExist(x.orderSentVolume) ? renderLitresToHL(x.orderSentVolume, 2) : '0',
		orderSentCount: valueExist(x.orderSentCount) ? numberWithSpaces(x.orderSentCount) : '0',
	}));

	return gridData
}